module.exports = __webpack_public_path__ + "static/img/jz-logo.be5a1bc8.png";